import Swiper from '../lib/swiper/swiper-bundle.js';

// * Home

if ($('.main-poster__slider').length > 0) {
    var mainBigPoster = new Swiper('.main-poster__slider.swiper-container', {
        loop: true,
        direction: 'horizontal',
        slidesPerView: 1.05,
        speed: 700,
        spaceBetween: 10,
        navigation: {
            nextEl: '.swiper-button-next.main-poster__next',
            prevEl: '.swiper-button-prev.main-poster__prev',
        },
        pagination: {
            el: '.swiper-pagination.main-poster__pagination',
            clickable: true
        },
        breakpoints: {
            320: {
                slidesPerView: 1,
            },
            768: {
                slidesPerView: 1,
                slidesPerScroll: 1,
            },
            1199: {
                slidesPerView: 1.05,
                slidesPerScroll: 1,
            }
        }
    });
}
if ($('.main-baner__slider ').length > 0) {
    var mainBanerSlider = new Swiper('.main-baner__slider.swiper-container', {
        // Optional parameters
        direction: 'horizontal',
        loop: true,
        slidesPerView: 1,
        speed: 700,
        spaceBetween: 0,
        // If we need pagination
        // navigation: {
        // 	nextEl: '.swiper-button-next.main-articles__next',
        // 	prevEl: '.swiper-button-prev.main-articles__prev',
        // },
        pagination: {
            el: '.swiper-pagination.main-baner__pagination',
            clickable: true
        },


    });
}
if ($('.main-articles__slider').length > 0) {
    var mainArticles = new Swiper('.main-articles__slider.swiper-container', {
        // Optional parameters
        direction: 'horizontal',
        loop: true,
        slidesPerView: 3,
        speed: 700,
        slidesPerGroup: 3,
        spaceBetween: 20,
        // If we need pagination
        navigation: {
            nextEl: '.swiper-button-next.main-articles__next',
            prevEl: '.swiper-button-prev.main-articles__prev',
        },
        pagination: {
            el: '.swiper-pagination.main-articles__pagination',
            clickable: true
        },
        breakpoints: {
            320: {
                slidesPerView: 1.2,
                slidesPerGroup: 1,
            },
            560: {
                slidesPerView: 2,
                slidesPerGroup: 2,
            },
            991: {
                slidesPerView: 3,
                slidesPerGroup: 3,
            },
        }
    });
}
if ($('.main-reviews__slider').length > 0) {
    var mainReviews = new Swiper('.main-reviews__slider.swiper-container', {
        // Optional parameters
        direction: 'horizontal',
        loop: true,
        slidesPerView: 3,
        speed: 700,
        slidesPerGroup: 3,
        spaceBetween: 20,
        // If we need pagination
        navigation: {
            nextEl: '.swiper-button-next.main-reviews__swiper-next',
            prevEl: '.swiper-button-prev.main-reviews__swiper-prev',
        },
        pagination: {
            el: '.swiper-pagination.main-reviews__pagination',
            clickable: true
        },
        breakpoints: {
            320: {
                slidesPerView: 1,
                slidesPerGroup: 1,
            },
            768: {
                slidesPerView: 2,
                slidesPerGroup: 2,
            },
            991: {
                slidesPerView: 3,
                slidesPerGroup: 3,
            },
        }
    });
}
if ($('.main-reviews__slider-client').length > 0) {
    var mainReviewsClient = new Swiper('.main-reviews__slider-client.swiper-container', {
        // Optional parameters
        direction: 'horizontal',
        loop: true,
        slidesPerView: 3,
        speed: 700,
        slidesPerGroup: 3,
        spaceBetween: 20,
        // If we need pagination
        pagination: {
            el: '.swiper-pagination.main-reviews-client__pagination',
            clickable: true
        },
        breakpoints: {
            320: {
                slidesPerView: 1,
                slidesPerGroup: 1,
            },
            768: {
                slidesPerView: 2,
                slidesPerGroup: 2,
            },
            991: {
                slidesPerView: 3,
                slidesPerGroup: 3,
            },
        }
    });
}
if ($('.big-banner__slider').length > 0) {
    var BigBanner = new Swiper('.big-banner__slider.swiper-container', {
        // Optional parameters
        direction: 'horizontal',
        loop: true,
        slidesPerView: 2,
        slidesPerGroup: 2,
        speed: 700,
        spaceBetween: 20,
        // If we need pagination
        navigation: {
            nextEl: '.big-banner__next.swiper-button-next',
            prevEl: '.big-banner__prev.swiper-button-prev',
        },
        pagination: {
            el: '.swiper-pagination.big-banner__pagination',
            clickable: true
        },
        breakpoints: {
            320: {
                slidesPerView: 1,
                slidesPerGroup: 1,
            },
            992: {
                slidesPerView: 2,
                slidesPerGroup: 2,
            },
        }
    });
}
if( $('.aside-certificates__mobile').length > 0 && window.innerWidth <= 767 ){
    var asideCertificates = new Swiper('.aside-certificates__mobile ', {
        slidesPerView: 2,
        spaceBetween: 25,
        pagination: {
            el: '.swiper-pagination',
            clickable: true
        },
    });
}